export default (onSuccess, onExit, token) => {
  return {
    onSuccess,
    onExit,
    token,
  };
};
